import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec371b8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "DatabaseConfig" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { class: "itemEdit" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, "使用项目：", -1))
const _hoisted_9 = {
  key: 0,
  style: {"font-size":"15px"}
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = { style: {"margin-top":"10px"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, "数 据  库：", -1))
const _hoisted_16 = { style: {"font-size":"15px"} }
const _hoisted_17 = { style: {"margin-top":"10px"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, "使用账号：", -1))
const _hoisted_19 = { style: {"font-size":"15px"} }
const _hoisted_20 = { style: {"margin-top":"10px"} }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { style: {"color":"red"} }, "* ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, "原密码：", -1))
const _hoisted_23 = { style: {"margin-top":"10px"} }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { style: {"color":"red"} }, "* ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, "新密码：", -1))
const _hoisted_26 = { style: {"margin-top":"10px"} }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { style: {"color":"red"} }, "* ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, "确认密码：", -1))
const _hoisted_29 = { class: "button-footer" }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {modalConfig} from './config/modal.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {ref} from "vue";
import {usePageModal} from '@/hooks/usePageModal'
import {ElLoading, ElMessageBox, ElNotification} from "element-plus";
import useClipboard from "vue-clipboard3";
import {initEmptyParam} from "@/hooks/useInitParam";
import {useRouter} from "vue-router";
import {useStore} from "@/store";
import {ElMessage} from "element-plus/es";
import {getListData, postData} from "@/service/main/system";


export default /*#__PURE__*/_defineComponent({
  __name: 'DatabaseConfig',
  setup(__props, { expose: __expose }) {

initEmptyParam()

const otherInfo = ref({})

const modalTitle = ref('编辑数据库')

const router = useRouter()
const store = useStore()

const {toClipboard} = useClipboard()

const copyPassword = async (pwd: string) => {
  try {
    await toClipboard(pwd)
    ElNotification({
      title: '复制成功',
      message: '请点击前往阿里云',
      type: 'success'
    })
  } catch (e) {
    ElNotification({
      title: '复制失败',
      message: '请等一会，复制',
      type: 'error'
    })
  }
}

const handleGoToAliyunClick = (item: any) => {
  window.open(item.aliyunUrl, '_blank')
}

const handleUpdateAll = () => {
  const reportUrl = router.resolve({
    path: '/main/helper/databaseConfig/allUpdate'
  }).href

  // 获取屏幕的宽度和高度
  const screenWidth = window.screen.width
  const screenHeight = window.screen.height

  const width = screenWidth * 0.6
  const height = screenHeight * 0.8

  // 计算新窗口的左上角位置，使其居中
  const leftPosition = screenWidth / 2 - width / 2
  const topPosition = screenHeight / 2 - height / 2 - 50

  // 创建弹出窗口
  const options = `width=${width},height=${height},left=${leftPosition},top=${topPosition},toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes`
  const popupWindow = window.open(reportUrl, '修改', options)
  if (popupWindow) {
    popupWindow.onbeforeunload = function () {
      const queryInfo = store.state.system.queryInfo
      pageContentRef.value?.getPageData(queryInfo)
    }
  }
}

const editDialogVisible = ref(false)
const databaseInfo = ref()
const handleEditData = (item: any) => {
  databaseInfo.value = {...item}
  editDialogVisible.value = true
}

let connectInterval: number | null = null
const confirmAndRestart = () => {
  if (databaseInfo.value.originalPassword == undefined || databaseInfo.value.originalPassword == '' || databaseInfo.value.newPassword == undefined || databaseInfo.value.newPassword == '' || databaseInfo.value.againPassword == undefined || databaseInfo.value.againPassword == '') {
    ElMessage({
      message: '原始密码、新密码和确认密码不能为空',
      type: 'warning',
      showClose: true
    })
    return
  } else {
    if (databaseInfo.value.password !== databaseInfo.value.originalPassword) {
      ElMessage({
        message: '原始密码错误',
        type: 'error',
        showClose: true
      })
      return
    }

    if (databaseInfo.value.newPassword !== databaseInfo.value.againPassword) {
      ElMessage({
        message: '两次输入密码不一致',
        type: 'error',
        showClose: true
      })
      return
    }

    ElMessageBox.confirm('是否立即重启该项目， 重启过程中会对数据库进行连接测试，请注意测试结果！！！', '提示', {
      confirmButtonText: '立即重启',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      const testDatabaseLoading = ElLoading.service({
        lock: true,
        text: '数据库连接测试中',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      postData('/main/databaseConfig/updatePwdById', {jsonStr: encodeURIComponent(JSON.stringify(databaseInfo.value))}).then((result) => {
        testDatabaseLoading.close()
        if (result.includes('成功')) {
          ElMessage({
            message: result,
            type: 'success',
            showClose: true
          })

          setTimeout(() => {
            const restartLoading = ElLoading.service({
              lock: true,
              text: '项目重启中，重启时间比较久，请耐心等待',
              background: 'rgba(0, 0, 0, 0.7)',
            })
            if (connectInterval) return
            connectInterval = setInterval(() => {
              console.log('尝试调用接口')
              getListData('/main/databaseConfig/getProjectStatus', {}).then((result) => {
                if (result == '启动成功') {
                  stopTestConnect()
                  restartLoading.close()
                  ElMessage({
                    message: '重启成功！！！',
                    type: 'success',
                    showClose: true
                  })
                  editDialogVisible.value = false
                }
              })
            }, 20000)
            postData('/main/databaseConfig/restartProject', {})
          }, 500)
        } else {
          ElMessage({
            message: result,
            type: 'error',
            showClose: true
          })
          return
        }
      })
    })
  }
}

function stopTestConnect() {
  if (connectInterval) {
    clearInterval(connectInterval)
    connectInterval = null
  }
}

const [pageModalRef, defaultInfo, handleNewData] = usePageModal()
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

// 清理定时器
__expose({stopTestConnect})

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_PageModal = _resolveComponent("PageModal")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "databaseConfig",
      onEditBtnClick: handleEditData,
      onGoToAliyunClick: handleGoToAliyunClick,
      onUpdateAll: handleUpdateAll
    }, {
      belongType: _withCtx((scope) => [
        (scope.row.belongType === '1')
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "运营辅助平台"))
          : (scope.row.belongType === '2')
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "微控平台"))
            : (scope.row.belongType === '3')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "直播间 "))
              : (scope.row.belongType === '4')
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "企业微信检查系统"))
                : (scope.row.belongType === '5')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "与牛共舞"))
                  : _createCommentVNode("", true)
      ]),
      password: _withCtx((scope) => [
        _createVNode(_component_el_button, {
          size: "mini",
          type: "primary",
          onClick: ($event: any) => (copyPassword(scope.row.aliyunPassword))
        }, {
          default: _withCtx(() => [
            _createTextVNode("点击复制")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["contentTableConfig"]),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "databaseConfig",
      otherInfo: otherInfo.value,
      validOtherInfo: () => true
    }, null, 8, ["defaultInfo", "modalConfig", "title", "otherInfo"]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_dialog, {
        title: modalTitle.value,
        modelValue: editDialogVisible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editDialogVisible).value = $event)),
        width: "30%",
        center: "",
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _hoisted_8,
            (databaseInfo.value.belongType === '1')
              ? (_openBlock(), _createElementBlock("strong", _hoisted_9, "运营辅助平台"))
              : (databaseInfo.value.belongType === '2')
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "微控平台"))
                : (databaseInfo.value.belongType === '3')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "直播间 "))
                  : (databaseInfo.value.belongType === '4')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "企业微信检查系统"))
                    : (databaseInfo.value.belongType === '5')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, "与牛共舞"))
                      : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("strong", _hoisted_16, _toDisplayString(databaseInfo.value.environment), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("strong", _hoisted_19, _toDisplayString(databaseInfo.value.username), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _hoisted_22,
            _createVNode(_component_el_input, {
              modelValue: databaseInfo.value.originalPassword,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((databaseInfo.value.originalPassword) = $event)),
              type: "password"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _hoisted_25,
            _createVNode(_component_el_input, {
              modelValue: databaseInfo.value.newPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((databaseInfo.value.newPassword) = $event)),
              type: "password"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _hoisted_28,
            _createVNode(_component_el_input, {
              modelValue: databaseInfo.value.againPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((databaseInfo.value.againPassword) = $event)),
              type: "password"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (editDialogVisible.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              style: {"margin-left":"20px"},
              type: "primary",
              onClick: confirmAndRestart
            }, {
              default: _withCtx(() => [
                _createTextVNode("确认并重启")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["title", "modelValue"])
    ])
  ]))
}
}

})